var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { apiFetch, StyledButton, StyledButtonStyle, useData, } from "ee-react-components";
import { orchestratorUrl } from "./api";
var signalsKey = function () { return "".concat(orchestratorUrl(), "/signals"); };
var signalRunsKey = function (id) {
    return "".concat(orchestratorUrl(), "/signals/").concat(id, "/runs?limit=20");
};
var signalRunDetailKey = function (signalId, runId) {
    return "".concat(orchestratorUrl(), "/signals/").concat(signalId, "/runs/").concat(runId);
};
export var SignalsTab = function () {
    var _a = useData(signalsKey()), signals = _a.data, refreshSignals = _a.execute;
    return (React.createElement("div", { className: "flex flex-col gap-y-[24px]" },
        React.createElement("h2", { className: "text-white font-N6" }, "Signals"),
        !signals && React.createElement("span", { className: "text-black-600 font-N8" }, "Loading\u2026"),
        signals && signals.length === 0 && (React.createElement("span", { className: "text-black-600 font-N8" }, "No signals registered.")),
        signals && signals.length > 0 && (React.createElement("div", { className: "flex flex-col rounded-[10px] overflow-hidden border border-black-800" },
            React.createElement("div", { className: "grid grid-cols-[3fr_1fr_1fr_1fr_1fr] bg-black-900 px-[12px] py-[8px] text-black-400 font-N8 uppercase text-[10px] tracking-wide" },
                React.createElement("span", null, "Name"),
                React.createElement("span", null, "Interval"),
                React.createElement("span", null, "Prediction"),
                React.createElement("span", null, "Lookahead"),
                React.createElement("span", null, "Enabled")),
            signals.map(function (s) { return (React.createElement(Disclosure, { key: s.id }, function (_a) {
                var open = _a.open;
                return (React.createElement("div", null,
                    React.createElement(Disclosure.Button, { className: "w-full text-left grid grid-cols-[3fr_1fr_1fr_1fr_1fr] px-[12px] py-[10px] border-t border-black-800 hover:bg-black-900 transition-colors" },
                        React.createElement("span", { className: "text-white font-N8" }, s.name),
                        React.createElement("span", { className: "text-white font-N8" },
                            s.intervalLengthMinutes,
                            "m"),
                        React.createElement("span", { className: "text-white font-N8" },
                            s.predictionIntervalMinutes,
                            "m"),
                        React.createElement("span", { className: "text-white font-N8" },
                            s.lookaheadStartMinutes,
                            "m"),
                        React.createElement("span", { className: "text-white font-N8 flex items-center gap-x-[4px]" },
                            s.enabled ? "yes" : "no",
                            React.createElement(ChevronDownIcon, { className: "w-[12px] h-[12px] ml-auto text-black-600 transition-transform ".concat(open ? "" : "rotate-180") }))),
                    React.createElement(Disclosure.Panel, null,
                        React.createElement(SignalExpansion, { signal: s, onChanged: refreshSignals }))));
            })); })))));
};
// ─── Signal expansion ────────────────────────────────────────────────────────
var SignalExpansion = function (_a) {
    var signal = _a.signal, onChanged = _a.onChanged;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _b = useState(false), toggling = _b[0], setToggling = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var runs = useData(signalRunsKey(signal.id)).data;
    var onToggle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var getToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setToggling(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: { audience: process.env.AUTH0_AUDIENCE },
                        });
                    };
                    return [4 /*yield*/, apiFetch("".concat(orchestratorUrl(), "/signals/").concat(signal.id, "/enabled"), {
                            method: "PATCH",
                            body: { enabled: !signal.enabled },
                            callbacks: { getToken: getToken },
                        })];
                case 2:
                    _a.sent();
                    onChanged();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 5];
                case 4:
                    setToggling(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "border-t border-black-800 bg-black-1100 p-[16px] flex flex-col gap-y-[16px]" },
        signal.description && (React.createElement("div", { className: "grid grid-cols-2 gap-x-[24px] gap-y-[12px]" },
            React.createElement(Param, { label: "Description", value: signal.description }))),
        React.createElement("div", { className: "flex flex-row items-center gap-x-[8px]" },
            React.createElement(StyledButton, { text: signal.enabled ? "Disable" : "Enable", style: signal.enabled ? StyledButtonStyle.Gray : StyledButtonStyle.Green, disabled: toggling, onClick: function () { return void onToggle(); } }),
            error && React.createElement("span", { className: "text-red font-N8" }, error)),
        React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
            React.createElement("span", { className: "text-white font-N7" }, "Recent runs"),
            !runs && React.createElement("span", { className: "text-black-600 font-N8" }, "Loading\u2026"),
            runs && runs.length === 0 && (React.createElement("span", { className: "text-black-600 font-N8" }, "No runs yet.")),
            runs && runs.length > 0 && (React.createElement("div", { className: "flex flex-col rounded-[10px] overflow-hidden border border-black-800" },
                React.createElement("div", { className: "grid grid-cols-[2fr_2fr_2fr_1fr_1fr] bg-black-900 px-[12px] py-[8px] text-black-400 font-N8 uppercase text-[10px] tracking-wide" },
                    React.createElement("span", null, "Started"),
                    React.createElement("span", null, "Completed"),
                    React.createElement("span", null, "Window"),
                    React.createElement("span", null, "Status"),
                    React.createElement("span", null, "Logs")),
                runs.map(function (run) { return (React.createElement(Disclosure, { key: run.id }, function (_a) {
                    var open = _a.open;
                    return (React.createElement("div", null,
                        React.createElement(Disclosure.Button, { className: "w-full text-left grid grid-cols-[2fr_2fr_2fr_1fr_1fr] px-[12px] py-[10px] border-t border-black-800 hover:bg-black-900 transition-colors" },
                            React.createElement("span", { className: "text-white font-N8" }, new Date(run.startedAt).toLocaleString()),
                            React.createElement("span", { className: "text-white font-N8" }, run.completedAt
                                ? new Date(run.completedAt).toLocaleString()
                                : "-"),
                            React.createElement("span", { className: "text-black-400 font-N8" }, run.predictionWindowStart && run.predictionWindowEnd
                                ? "".concat(new Date(run.predictionWindowStart).toLocaleTimeString(), " - ").concat(new Date(run.predictionWindowEnd).toLocaleTimeString())
                                : "-"),
                            React.createElement("span", { className: "font-N8 ".concat(run.status === "failed"
                                    ? "text-red"
                                    : run.status === "success"
                                        ? "text-green-400"
                                        : "text-yellow-400") }, run.status),
                            React.createElement("span", { className: "text-black-400 font-N8 flex items-center gap-x-[4px]" },
                                run.logCount,
                                React.createElement(ChevronDownIcon, { className: "w-[12px] h-[12px] ml-auto text-black-600 transition-transform ".concat(open ? "" : "rotate-180") }))),
                        React.createElement(Disclosure.Panel, null,
                            React.createElement("div", { className: "border-t border-black-800 bg-black-1100" },
                                React.createElement(RunLogs, { signalId: signal.id, runId: run.id })))));
                })); }))))));
};
// ─── Run logs ────────────────────────────────────────────────────────────────
var RunLogs = function (_a) {
    var signalId = _a.signalId, runId = _a.runId;
    var run = useData(signalRunDetailKey(signalId, runId)).data;
    if (!run) {
        return React.createElement("div", { className: "p-[12px] text-black-600 font-N8" }, "Loading logs\u2026");
    }
    return (React.createElement("div", { className: "p-[12px] font-mono text-[12px] max-h-[320px] overflow-auto flex flex-col gap-y-[2px]" },
        run.logs.length === 0 && (React.createElement("div", { className: "text-black-600" }, "No log entries.")),
        run.logs.map(function (entry, i) { return (React.createElement("div", { key: i, className: entry.level === "ERROR"
                ? "text-red"
                : entry.level === "WARN"
                    ? "text-yellow-400"
                    : "text-black-200" },
            React.createElement("span", { className: "text-black-600" }, new Date(entry.ts).toLocaleTimeString()),
            " ",
            React.createElement("span", { className: "font-bold" },
                "[",
                entry.level,
                "]"),
            " ",
            entry.message,
            entry.meta && (React.createElement("span", { className: "text-black-500" },
                " ",
                JSON.stringify(entry.meta))))); })));
};
var Param = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement("div", { className: "flex flex-col gap-y-[2px]" },
        React.createElement("span", { className: "text-black-500 uppercase text-[10px] tracking-[0.08em] font-semibold" }, label),
        React.createElement("span", { className: "text-white font-N7 text-[14px]" }, value)));
};
